/**
 * @generated SignedSource<<6bd31a46338b5dcf7d43180a102dc09d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DisplaySettingsModal_user$data = {
  readonly addressBook: {
    readonly personalAddress: {
      readonly country: string | null;
      readonly displayCountry: string | null;
    } | null;
  } | null;
  readonly id: string;
  readonly profile: {
    readonly currency: Currency | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "DisplaySettingsModal_user";
};
export type DisplaySettingsModal_user$key = {
  readonly " $data"?: DisplaySettingsModal_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"DisplaySettingsModal_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DisplaySettingsModal_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AddressBook",
      "kind": "LinkedField",
      "name": "addressBook",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "personalAddress",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "country",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayCountry",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "220adf7d516f7bf79c8d7a99312aa705";

export default node;
